import { FC } from 'react';
import styled from 'styled-components';

import TertiaryButton, { TertiaryButtonProps } from '../../buttons/TertiaryButton';

export const StyledTertiaryButton = styled<FC<TertiaryButtonProps & {inline: boolean}>>(TertiaryButton)`
  ${({ inline }) => inline && `
    position: relative;
    margin-top: -8px;
    margin-bottom: 8px;
  `}
`;
